var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocDestinationFlag1WhiteC84(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    fillRule: "evenodd",
    d: "M12 1.5v3h4.5v30h-15v-30H6v-3h6zM15 6H3v27h12V6zm-1.5 21.75v3.75h-9v-3.75h9zM21.75 15v19.5h-1.5V15h1.5zm3.75 9v2.25h-2.25V24h2.25zm4.5 0v2.25h-2.25V24H30zm4.5 0v2.25h-2.25V24h2.25zm-6.75-2.25V24H25.5v-2.25h2.25zm4.5 0V24H30v-2.25h2.25zM25.5 19.5v2.25h-2.25V19.5h2.25zm4.5 0v2.25h-2.25V19.5H30zm4.5 0v2.25h-2.25V19.5h2.25zm-6.75-2.25v2.25H25.5v-2.25h2.25zm4.5 0v2.25H30v-2.25h2.25zM25.5 15v2.25h-2.25V15h2.25zm4.5 0v2.25h-2.25V15H30zm4.5 0v2.25h-2.25V15h2.25z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocDestinationFlag1WhiteC84);
export default __webpack_public_path__ + "static/media/soc_destination_flag_1_white_C8.4.3e9aee150159f6798f8f6393e3fe0641.svg";
export { ForwardRef as ReactComponent };